
import { defineComponent } from "vue";
import Button from "@/components/controls/ButtonControl.vue";
import mixin from "@/mixin";

export default defineComponent({
    components: {
        Button
    },
    mixins: [
        mixin,
    ],
});
